var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "leading-5 font-normal", class: _vm.linkSize },
    [
      _vm.external
        ? _c(
            "a",
            {
              staticClass:
                "cursor-pointer text-badgeBlue hover:text-blue-600 text-base hover:underline font-outfit focus:outline-none focus:underline transition ease-in-out duration-150",
              attrs: { target: "_blank", href: _vm.link },
            },
            [_vm._v(" " + _vm._s(_vm.text) + " ")]
          )
        : _vm.routerTo
        ? _c(
            "RouterLink",
            {
              staticClass:
                "text-badgeBlue hover:text-blue-600 text-base hover:underline font-outfit focus:outline-none focus:underline transition ease-in-out duration-150",
              attrs: { to: _vm.routerTo },
            },
            [_vm._v(" " + _vm._s(_vm.text) + " ")]
          )
        : _c(
            "a",
            {
              staticClass:
                "cursor-pointer text-badgeBlue text-base hover:text-blue-600 hover:underline font-outfit focus:outline-none focus:underline transition ease-in-out duration-150",
              on: {
                click: function ($event) {
                  return _vm.$emit("click")
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.text) + " ")]
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }